export default "__VITE_ASSET__BcBzspnv__"